import { getAnalytics, track } from './utils';
import './snippet';
const disabledMiddleware = _ => next => action => {
    next(action);
};
export function createAnalyticsMiddleware(apiKey) {
    if (!apiKey) {
        console.warn('Analytics: middleware disabled due to missing API key');
        return disabledMiddleware;
    }
    const analytics = getAnalytics();
    if (!analytics) {
        console.warn('Analytics: middleware disabled because `window.analytics` is not present');
        return disabledMiddleware;
    }
    analytics.load(apiKey);
    return _ => next => action => {
        track(action);
        next(action);
    };
}
//# sourceMappingURL=middleware.js.map